import Phaser from 'phaser';

const SKY_TOP = 0x0b0614;
const SKY_BOTTOM = 0x3b0d20;
const FOG = 0x7f1d1d;
const SILHOUETTE = 0x050308;
const SILHOUETTE_DEEP = 0x020104;
const NEON_RED = 0xef4444;
const NEON_YELLOW = 0xfacc15;
const WINDOW_DIM = 0x991b1b;
const LAMP = 0xfde68a;

export function drawHellsKitchenSkyBackground(
  g: Phaser.GameObjects.Graphics,
  w: number,
  h: number,
) {
  g.clear();
  const step = Math.max(1, Math.floor(h / 48));
  for (let y = 0; y < h; y += step) {
    const t = y / h;
    const r = lerp((SKY_TOP >> 16) & 0xff, (SKY_BOTTOM >> 16) & 0xff, t);
    const gC = lerp((SKY_TOP >> 8) & 0xff, (SKY_BOTTOM >> 8) & 0xff, t);
    const b = lerp(SKY_TOP & 0xff, SKY_BOTTOM & 0xff, t);
    g.fillStyle((r << 16) | (gC << 8) | b, 1);
    g.fillRect(0, y, w, step + 1);
  }

  const rand = mulberry32(6119);
  g.fillStyle(FOG, 0.18);
  for (let i = 0; i < 8; i++) {
    const cx = rand() * w;
    const cy = h * 0.35 + rand() * h * 0.35;
    g.fillEllipse(cx, cy, 180 + rand() * 120, 50);
  }

  g.fillStyle(LAMP, 0.95);
  const moonX = Math.floor(w * 0.82);
  const moonY = Math.floor(h * 0.18);
  g.fillCircle(moonX, moonY, 18);
  g.fillStyle(0xffffff, 0.25);
  g.fillCircle(moonX + 4, moonY - 4, 6);
}

export function drawHellsKitchenSilhouette(
  g: Phaser.GameObjects.Graphics,
  w: number,
  h: number,
  seed = 1312,
) {
  const rand = mulberry32(seed);
  const baselineY = Math.floor(h * 0.74);
  const maxBuildingH = Math.floor(h * 0.44);

  g.fillStyle(SILHOUETTE_DEEP, 1);
  g.fillRect(0, baselineY + Math.floor(maxBuildingH * 0.5), w, h - baselineY);

  let x = -20;
  while (x < w + 20) {
    const bw = 24 + Math.floor(rand() * 70);
    const bh = Math.floor(maxBuildingH * (0.4 + rand() * 0.85));
    const by = baselineY + (maxBuildingH - bh);

    g.fillStyle(SILHOUETTE, 1);
    g.fillRect(x, by, bw, h - by);

    const hasFireEscape = rand() < 0.55;
    if (hasFireEscape) {
      g.fillStyle(0x111318, 1);
      const fx = x + Math.floor(bw * 0.25);
      for (let i = 0; i < Math.floor(bh / 18); i++) {
        const py = by + 10 + i * 18;
        if (py > h - 8) continue;
        g.fillRect(fx, py, bw * 0.12, 3);
        g.fillRect(fx, py, 2, 14);
      }
    }

    const cols = Math.max(2, Math.floor(bw / 12));
    const rows = Math.max(3, Math.floor(bh / 16));
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        if (rand() > 0.5) continue;
        const wx = x + 3 + c * Math.floor(bw / cols);
        const wy = by + 5 + r * 14;
        if (wy > h - 4) continue;
        g.fillStyle(rand() < 0.2 ? NEON_YELLOW : WINDOW_DIM, 0.85);
        g.fillRect(wx, wy, 4, 5);
      }
    }

    x += bw - Math.floor(rand() * 6);
  }

  const signY = Math.floor(h * 0.45);
  g.fillStyle(NEON_RED, 1);
  g.fillRect(Math.floor(w * 0.15), signY, 60, 8);
  g.fillStyle(NEON_RED, 0.5);
  g.fillRect(Math.floor(w * 0.15) - 4, signY - 4, 68, 16);

  g.fillStyle(NEON_YELLOW, 1);
  g.fillRect(Math.floor(w * 0.55), signY + 20, 70, 6);
  g.fillStyle(NEON_YELLOW, 0.4);
  g.fillRect(Math.floor(w * 0.55) - 4, signY + 16, 78, 14);

  g.fillStyle(LAMP, 0.85);
  g.fillCircle(Math.floor(w * 0.28), baselineY + maxBuildingH - 30, 4);
  g.fillStyle(LAMP, 0.3);
  g.fillCircle(Math.floor(w * 0.28), baselineY + maxBuildingH - 30, 12);
}

function lerp(a: number, b: number, t: number): number {
  return Math.round(a + (b - a) * t);
}

function mulberry32(seed: number) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
